import { inject, Injectable, LOCALE_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Router, RouteReuseStrategy } from '@angular/router';
import { AppRouteReuseStrategy } from '../../app-route-reuse.strategy';
import { environment } from '../environments/environment';
import { UriApi } from '../helpers/UriApi';
import { Constants } from '../helpers/constants';
import { TabService } from './tab.service';

@Injectable()
export class AuthenticationService {

    reuseStrategy = inject(RouteReuseStrategy) as AppRouteReuseStrategy;
    constructor(private http: HttpClient, private router: Router, private tabService: TabService) { }

    getApiKey(): string {
        let ApiKey = environment.apiKey;
        return ApiKey;
    }

    getPrivateKeyUser(): any {
        return environment.private_keyuser;
    }

    login(body: any, auto_login: boolean) {
        var options = {
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': this.getApiKey()
            },
        };
        return this.http.post<any>(UriApi.api_authen, body, options)
            .pipe(map(user => {
                if (user?.isOK) {
                    let userEncrypt = Constants.encryptWithKey(JSON.stringify(user), this.getPrivateKeyUser());
                    if (auto_login) localStorage.setItem(Constants.CurrentUser, userEncrypt);
                    else sessionStorage.setItem(Constants.CurrentUser, userEncrypt);
                }

                return user;
            }));
    }

    currentUser() {
        var u = localStorage.getItem(Constants.CurrentUser) || sessionStorage.getItem(Constants.CurrentUser);
        let dataUser;
        if (u === '' || u === null) {
            dataUser = null;
        }
        else {
            let userDecrypt = Constants.decryptWithKey(u, this.getPrivateKeyUser());
            dataUser = JSON.parse(userDecrypt);
        }
        return dataUser;
    }

    getToken() {
        var u = this.currentUser();
        return u !== null ? u.token : "";
    }

    getHQCD() {
        var u = this.currentUser();
        return u !== null ? u.hQ_CD : "";
    }

    getUserId() {
        var u = this.currentUser();
        return u !== null ? u.useR_ID : "";
    }

    getUserNm() {
        var u = this.currentUser();
        return u !== null ? u.useR_NM : "";
    }

    getStrCd() {
        var u = this.currentUser();
        return u !== null ? u.stR_CD : "";
    }

    logout() {
        this.tabService.closeAllTab();
        localStorage.removeItem(Constants.CurrentUser);
        localStorage.removeItem(Constants.CurrentMenu);
        sessionStorage.removeItem(Constants.CurrentUser);
        sessionStorage.removeItem(Constants.CurrentMenu);
        localStorage.removeItem(Constants.IsAdminLogin);
        localStorage.removeItem(Constants.CartTemp)
        setTimeout(() => this.reuseStrategy.removeAllRouteSnapshots(), 100);
        this.router.navigateByUrl('/login');
    }

    checkToken() {
        const token = {
            Authorization: this.getToken()
        };

        return fetch(UriApi.api_validToken, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': this.getApiKey()
            },
            body: JSON.stringify(token),
            credentials: 'include'

        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .catch(error => {
                console.error('Error during token validation:', error);
                throw error;
            });
    }

    replaceStorage(key: string, value: any) {
        const localValue = localStorage.getItem(key);
        const sessionValue = sessionStorage.getItem(key);

        if (localValue) {
            localStorage.setItem(key, value);
        } else if (sessionValue) {
            sessionStorage.setItem(key, value);
        }
    }
}